<template>
	<my-popup destroy-on-close :update="false" :visible.sync="visible" :modal-style="modalStyle">
        <div class="approve-container">
            <div class="approve-header" v-if="language.title" v-text="language.title"></div>
            <div class="approve-content">
            	<template v-if="language.content">
            		<span v-if="useHTMLString" v-html="language.content"></span>
            		<span v-else v-text="language.content"></span>
            		<!-- <span v-else v-text="language.content + language.content + language.content"></span> -->
            	</template>
            	<my-input
            		v-if="input"
            		v-model="value"
            		color="#000000"
            		:style="inputStyle"
            		borderColor="#909399"
            		:placeholder="language.placeholder">
            	</my-input>
            	<my-textarea
            		v-if="textarea"
            		v-model="value"
            		color="#000000"
            		borderColor="#909399"
            		:style="textareaStyle"
            		:placeholder="language.placeholder">
            	</my-textarea>
            </div>
            <div class="approve-footer" :style="footerStyle">
            	<my-button 
            		v-if="showCancelButton" 
            		class="approve-button" 
            		@click.stop="close('cancel')"
            		style="background-color: #909399;">
            		{{language.cancel}}
            	</my-button>
            	<my-button 
            		class="approve-button" 
            		@click.stop="close('confirm')"
            		style="background-color: #3270FF;margin-left: 20px;">
            		{{language.confirm}}
            	</my-button>
            </div>
        </div>
	</my-popup>
</template>

<script>
    import getText from '../getText.js'
	import myPopup from '../../components/my-popup.vue'
	import myInput from '../../components/my-input.vue'
	import myButton from '../../components/my-button.vue'
	import myTextarea from '../../components/my-textarea.vue'
	export default {
		name: 'approve',
		data() {
			return {
				// input和textarea只能选择显示一个
				visible: false,
				myVue: null,
				value: '',
				input: false,
				title: '',
				cancel: '',
				confirm: '',
				content: '',
				textarea: false,
				placeholder: '',
				beforeClose: null,
				closeResolve: null,
				useHTMLString: false,
				showCancelButton: true,
				closeOnClickModal: true
			}
		},
		methods: {
			show(params = {}, myVue) {
				this.myVue = myVue;
				this.value = '';
				this.input = false;
				this.title = '';
				this.cancel = '';
				this.confirm = '';
				this.content = '';
				this.textarea = false;
				this.placeholder = '';
				this.beforeClose = null;
				this.useHTMLString = false;
				this.showCancelButton = true;
				this.closeOnClickModal = true;
				return new Promise(resolve => {
					const keys = ['input', 'title', 'cancel', 'confirm', 'content', 'textarea', 'placeholder', 'beforeClose', 'useHTMLString', 'showCancelButton', 'closeOnClickModal'];
					keys.forEach(key => this[key] = (key in params) ? params[key] : this[key]);
					(params.input || params.textarea) && (this.value = '');
					this.closeResolve = resolve;
					this.visible = true;
				});
			},
			async close(status) {
				const data = Object.create(null);
				data['status'] = status;
				let close = true;
				if (status === 'confirm') {
					if (this.beforeClose && (typeof this.beforeClose === 'function')) {
						if (this.input || this.textarea) {
							data['value'] = this.value;
							close = await this.beforeClose(this.value);
						} else {
							close = await this.beforeClose();
						}
					}
				}
				if (close) {
					this.closeResolve(data);
					this.visible = false;
				}
			}
		},
		computed: {
			language() {
				const title = getText(this, this.title, '', '');
				const content = getText(this, this.content, '', '');
				const cancel = getText(this, this.cancel, 'cancel', '取消');
				const confirm = getText(this, this.confirm, 'confirm', '确认');
				const placeholder = getText(this, this.placeholder, 'pleaseEnter', '请输入');
				return {
					title,
					cancel,
					confirm,
					content,
					placeholder
				};
			},
			modalStyle() {
				const config = Object.create(null);
				config['zIndex'] = 9995;
				config['backgroundColor'] =  'rgba(0, 0, 0, 0.5)';
				return config;
			},
			inputStyle() {
				if (this.content && this.textarea) {
					return 'margin: 15px 0;';
				}
				if (this.content) {
					return 'margin: 15px 0 0;';
				}
				if (this.textarea) {
					return 'margin: 0 0 15px;';
				}
				return '';
			},
			textareaStyle() {
				if (this.content && !this.input) {
					return 'width: 100%;margin: 15px 0 0;';
				}
				return 'width: 100%;';
			},
			footerStyle() {
				return `justify-content: ${this.showCancelButton ? 'space-around' : 'flex-end'};`;
			}
		},
		components: {
			'my-popup': myPopup,
			'my-input': myInput,
			'my-button': myButton,
			'my-textarea': myTextarea
		}
	}
</script>

<style scoped lang="less">
    .approve-container{
        padding: 20px;
        width: calc(100vw - 80px);
        max-width: 460px;
        min-width: 240px;
        max-height: 560px;
        background-color: #FFFFFF;
        .approve-header, .approve-content, .approve-footer{
        	width: 100%;
        }
        .approve-header{
        	height: 3rem;
        	line-height: 3rem;
        	font-size: 1.8rem;
        	text-align: center;
        	padding-bottom: 15px;
        }
        .approve-content{
        	text-align: left;
        	font-size: 1.6rem;
        	line-height: 2.4rem;
        }
        .approve-footer{
        	display: flex;
        	padding-top: 15px;
        	align-items: flex-end;
        	.approve-button{
        		width: 90px;
        		height: 40px;
        		color: #FFFFFF;
        		font-size: 1.6rem;
        		border-radius: 40px;
        	}
        }
    }
</style>